import { Box, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { FC } from "react";

import CustomModal from "./CustomModal";

const ImagePreviewer: FC<ImagePreviewerProps> = ({ src, alt, width = "100px", height = "100px" }) => {
  return (
    <div>
      <CustomModal
        ModalOpenButton={
          <Box
            style={{
              width,
              height,
              overflow: "hidden",
              border: "1px solid #ccc",
              borderRadius: 5,
              cursor: "pointer",
            }}
          >
            <img src={src} alt={alt} loading="lazy" style={{ width: "100%", objectFit: "cover" }} />
          </Box>
        }
      >
        {(props: any) => (
          <Box height="75vh" display="flex" alignItems="center" justifyContent="center">
            <Box overflow="auto" height="100%">
              <Box display="flex" justifyContent="flex-end" mb={1}>
                <IconButton onClick={props.handleCloseModal}>
                  <CloseIcon />
                </IconButton>
              </Box>
              <Box mb={1} height="90%" overflow="auto">
                <img src={src} alt={alt} loading="lazy" />
              </Box>
            </Box>
          </Box>
        )}
      </CustomModal>
    </div>
  );
};

interface ImagePreviewerProps {
  src: string;
  alt: string;
  width?: string;
  height?: string;
}

export default ImagePreviewer;
